<template>
  <Layout :style="{minHeight: bodyHeight}">
    <Layout>
      <gSwiper></gSwiper>
    </Layout>
    <Layout>
      <Sider hide-trigger collapsible :collapsed-width="78" style="width: 255px;min-width: 255px;" class="side-en">
        <div class="side-logo">
          <img v-if="true" src="@assets/img/exhibition/logo-1.png" style="display: inline-block;" @click="$router.push('/exhibitionEn/index/home')" class="f-csp" />
          <img src="@assets/img/exhibition/logo.png" @click="$router.push('/exhibitionEn/index/home')" class="f-csp" v-else />
        </div>
        <gSide :siderArr="siderArr"></gSide>
      </Sider>
      <Layout style="height: 100%;width:calc(100% - 255px);" :style="{minHeight: bodyHeight}">
        <Header :style="{padding: 0}" class="layout-header-bar">
          <gHead></gHead>
        </Header>
        <Content>
          <div :style="{minHeight: '500px'}">
            <router-view />
          </div>
        </Content>
        <Footer>
          <copyright />
        </Footer>
      </Layout>
    </Layout>
    <Contact />
  </Layout>
</template>

<script>
import gHead from "@components/En/gHead/gHead";
import gSide from "@components/En/gSide/gSide";
import copyright from "@components/En/copyright/copyright";
import Contact from "@components/En/Contact/Contact";
import gSwiper from "@components/En/gSwiper/gSwiper.vue";
import { mapGetters } from "vuex";
export default {
  name: "exhibition-layout",
  data () {
    return {
      bodyHeight: "800px",
      siderArr: [
        {
          title: "Home",
          icon: "icon-shouye11",
          router: "/exhibitionEn/index/home",
          type: 1
        },
        {
          title: "Raw Space Construction",
          icon: "icon-zhuangxiu",
          router: "/exhibitionEn/index/build",
          type: 1,
        },
        // {
        //   title: "Raw Space Construction",
        //   icon: "icon-zhuangxiu",
        //   type: 2,
        //   children: [
        //     {
        //       title: "SYMA",
        //       router: "https://bjservice.syma.com.cn/BakeryChina.aspx",
        //     },
        //   ]
        // },
        {
          title: "Facial Board",
          icon: "icon-zhaopaisheji",
          router: "/exhibitionEn/index/exinfo/fascia-board",
          type: 1
        },
        {
          title: "Exhibitor Badge",
          icon: "icon-idcard-examine",
          router: "https://bakerychina.7-event.cn/exhibitor/login",
          type: 1
        },
        {
          title: "Visitor Badge",
          icon: "icon-zhengjian3",
          router: "https://bakerychina.7-event.cn/",
          type: 1
        },
        {
          title: "Vehicle Pass",
          icon: "icon-buchezhanchezheng",
          router: "/exhibitionEn/index/empty",
          type: 1
        },
        {
          title: "Exhibitor Manual",
          icon: "icon-download",
          router: "/exhibitionEn/index/exinfo/down",
          type: 1
        },
        {
          title: "Important",
          icon: "icon-zhuyi",
          router: "/exhibitionEn/index/exinfo/tip",
          type: 1
        },
        {
          title: "Contact",
          icon: "icon-lianxiren",
          router: "/exhibitionEn/index/exinfo/concact",
          type: 1
        },
        // {
        //   title: "订单中心",
        //   icon: "icon-dingdanzhongxin",
        //   router: "/exhibition/index/order",
        //   type: 1
        // },
        // {
        //   title: "图集管理",
        //   icon: "icon-sucaiku1",
        //   router: "/exhibition/index/photo",
        //   type: 1
        // },
        // {
        //   title: "Exhibiting",
        //   icon: "icon-diamonds",
        //   type: 2,
        //   children: [
        // {
        //   title: "我的展位图",
        //   router: "/exhibition/index/exinfo/boothImg"
        // },
        //     {
        //       title: "Catalogue Information",
        //       router: "/exhibitionEn/index/exinfo/catalogue"
        //     },
        //     {
        //       title: "Exhibitor's certificate application",
        //       router: "/exhibitionEn/index/exinfo/certApply"
        //     },
        //     {
        //       title: "Board information",
        //       router: "/exhibitionEn/index/exinfo/fascia-board"
        //     },
        //     {
        //       title: "Invoice（增值税发票）",
        //       router: "/exhibitionEn/index/exinfo/invoice"
        //     },
        //     {
        //       title: "Application for a license",
        //       router: "/exhibitionEn/index/exinfo/carApply"
        //     },
        //     {
        //       title: "Exhibitor Manual",
        //       router: "/exhibitionEn/index/exinfo/down"
        //     }
        //   ]
        // },
        // {
        //   title: "推广",
        //   icon: "icon-yijicaidanalituku_tuiguang",
        //   type: 2,
        //   children: [
        //     {
        //       title: "商机",
        //       router: "/exhibition/index/business"
        //     },
        //     {
        //       title: "商机",
        //       router: "/exhibition/index/release"
        //     },
        //     {
        //       title: "供需",
        //       router: "/exhibition/index/release-new"
        //     },
        //     {
        //       title: "动态",
        //       router: "/exhibition/index/moment"
        //     },
        //   ]
        // },
        // {
        //   title: "My Cloud shop",
        //   icon: "icon-guanli",
        //   type: 2,
        //   children: [
        //     {
        //       title: "Cloud shop settings",
        //       router: "/exhibitionEn/index/template"
        //     },
        //     {
        //       title: "Upload the product",
        //       router: "/exhibitionEn/index/product"
        //     },
        //     {
        //       title: "Product Presentation group",
        //       router: "/exhibitionEn/index/proGroup/productlist"
        //     },
        //     {
        //       title: "The activity plan",
        //       router: "/exhibitionEn/index/activity"
        //     },
        // {
        //   title: "人员",
        //   router: "/exhibition/index/companyAdmin"
        // },
        // {
        //   title: "案例",
        //   router: "/exhibition/index/case"
        // },
        // {
        //   title: "Brands",
        //   router: "/exhibitionEn/index/brand"
        // },
        // {
        //   title: "合作医院",
        //   router: "/exhibition/index/partner"
        // },
        //     {
        //       title: "Certificate of qualification",
        //       router: "/exhibitionEn/index/certificate"
        //     },
        //     {
        //       title: "Material Library",
        //       router: "/exhibitionEn/index/material"
        //     }
        //   ]
        // },
        {
          title: "Company Center",
          icon: "icon-peizhi1",
          type: 2,
          children: [
            // {
            //   title: "Basic Information",
            //   router: "/exhibitionEn/index/companyInfo"
            // },
            // {
            //   title: "管理员资料",
            //   router: "/exhibition/index/companyAdmin"
            // },
            // {
            //   title: "产品展示组",
            //   router: "/exhibition/index/proGroup/productlist"
            // },
            // {
            //   title: "Company News",
            //   router: "/exhibitionEn/index/news"
            // },
            // {
            //   title: "Sharing Settings",
            //   router: "/exhibitionEn/index/share"
            // },
            {
              title: "Account Security",
              router: "/exhibitionEn/index/companyAccount"
            }
          ]
        }
      ]
    };
  },
  components: {
    gHead,
    gSide,
    Contact,
    copyright,
    gSwiper
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition"
    })
  },
  created () {
    this.bodyHeight = window.innerHeight ? window.innerHeight + "px" : "800px";
    document.title = "国际焙烤展";
  }
};
</script>

<style lang="scss">
body {
  padding-right: 0 !important;
}
</style>
<style scoped lang='scss'>
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.side-logo {
  text-align: center;
  height: 64px;
  background-color: #fff;
  img {
    height: 60px;
  }
}
</style>